export { default, DetailedRatingsPopperAPI } from './DetailedRatingsPopper'
